// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PinCrossReference = t.struct({
    requestPin: t.maybe(t.String),
    responsePin: t.maybe(t.String)
}, {
    name: 'PinCrossReference',
    strict: true
});

export const getDefaultState = () => new PinCrossReference({});

export default PinCrossReference;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pin-cross-reference.js